import {useEffect, useState} from 'react';
import { Link } from 'react-router-dom';
import { TextAreaField } from '@aws-amplify/ui-react';
import { NavLink, useSearchParams } from "react-router-dom";
import Container from 'react-bootstrap/Container';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import React from "react";
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { API,Auth } from 'aws-amplify'
import Dropdown from 'react-bootstrap/Dropdown';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import axios from 'axios';
import Alert from 'react-bootstrap/Alert';

const ContentGeneration = () => {
    
    
    const initial_input = 'Draft a force majeure clause'
    
    const [input,setInput] = useState(initial_input)
    const [summary, setSummary] = useState('')
    const [isBusy, setIsBusy] = useState(false)
    const [time, setTime] = useState('')
    const [start, setStart] = useState(Date.now())
    const [end, setEnd] = useState(Date.now())
    const [errorMessage, setErrorMessage] = useState('');

    const summarize = async (e) => {
        
        // const url = "https://1gq3yxbzfa.execute-api.ca-central-1.amazonaws.com/stage/"
        const user = await Auth.currentAuthenticatedUser()
        const data = {'input_text': input}
        
        const url = "https://5pna04qxa9.execute-api.ca-central-1.amazonaws.com/lawai/generation"
    
        console.log(url)
        
        if (input.length < 4600) {
            // API.post('DocumentSearchUser', '/generation', 
            //     {
            //         method: "POST", 
            //         body: JSON.stringify(data),
            //         mode: 'cors',
            //         headers: {
            //             'Content-Type': 'application/json',
            //             "Accept": "application/json",
            //             // "Access-Control-Allow-Methods": "*",
            //             // 'Access-Control-Allow-Origin': '*',
            //             // 'x-api-key': 'nLq7HknRpT27UpcZHE2da76uavoH7L8d5uwtXR6X'
            //             'Authorization': user.signInUserSession.idToken.jwtToken
            //         }
            //     }
            // )
 
            // fetch('https://3lzbpof20l.execute-api.ca-central-1.amazonaws.com/dev/completion', {
            //   method: 'POST',
            //   headers: {
            //     'Content-Type': 'application/json',
            //     'Authorization': user.signInUserSession.idToken.jwtToken
            //   },
            //   body: JSON.stringify(data)
            // })
            // .then(response => response.json())
            // .then(response => {
            //     console.log(response)
            //     console.log(response.response)
            //     setSummary(response.response.replace(/^\s+/g, ''))
            // })
            // .then(data => {
            //     console.log(summary)
            // })
            // .then(() => {
            //     setIsBusy(isBusy => !isBusy)
            // })
            // .then(() =>{
            //     setEnd(Date.now())
            // })
            // .catch((err) => {
            //     console.log(err)
            // });

            axios({
                method: 'POST',
                headers: { 
                    'Content-Type': 'application/json',
                    "Accept": "application/json",
                    'x-api-key': 'zJylhxwbGO4qK0JOLQcU855STMwq1vrR5KuBzJed',
                    'Authorization': user.signInUserSession.idToken.jwtToken
                },
                data: JSON.stringify(data),
                url,
            })
            .then(response => {
                console.log(url)
                const { data } = response;
                console.log(data)
                setSummary(data.response.replace(/^\s+/g, ''))
                setIsBusy(isBusy => !isBusy);
            })
            .catch((err) => {
                setIsBusy(isBusy => !isBusy)
                console.log(err)
                if (err.response.status == 406) {
                    setErrorMessage(err.response.data);
                }
            });
            
        }
        else {
            alert('Please limit your input to 4600 characters')
            setIsBusy(false)
        }
        

        
        // setTime(Date())
    };
    // useEffect(() => {summarize(input)}, [])
    
    const Tick = (props) => {
        setTime(Date())
    }
    // useEffect(() => {Tick()}, [])
    setInterval(Tick, 0.001)
  

    // <p>Time: {time.substring(15,24)}</p>
    
	return (
        <Container>
            <Row>
                <Col>
                    <br />
                    <Breadcrumb>
                        <Breadcrumb.Item linkAs={Link} linkProps={{ to: "/" }}>Home</Breadcrumb.Item>
                        <Breadcrumb.Item active>Content Generator</Breadcrumb.Item>
                    </Breadcrumb>
                </Col>
            </Row>
            <Row>
                <Col style={{'padding': '25px'}}>
                    <h1>Content Generator</h1>
                </Col>
            </Row>
            <Row>
                <Col>
                    <div className='text-center'>
                        <Dropdown>
                            <Dropdown.Toggle variant="secondary" id="dropdown-basic">
                                Example Prompts
                            </Dropdown.Toggle>
            
                            <Dropdown.Menu>
                                <Dropdown.Item as="button" onClick={() => setInput('Draft a force majeure clause')}>
                                   Draft a force majeure clause
                                </Dropdown.Item>
                                <Dropdown.Item as="button" onClick={() => setInput('Draft a non-disclosure agreement')}>
                                   Draft a non-disclosure agreement
                                </Dropdown.Item>
                                <Dropdown.Item as="button" onClick={() => setInput('Draft an engagement letter for legal services')}>
                                   Draft an engagement letter for legal services
                                </Dropdown.Item>
                                <Dropdown.Item as="button" onClick={() => setInput('Draft a freedom of information and protection of privacy clause')}>
                                   Draft a freedom of information and protection of privacy clause
                                </Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    </div>
                </Col>
            </Row>
            <Row>
                <Col style={{'padding': '25px'}}>
                    <h2>Prompt</h2>
                    <TextAreaField 
                        alignContent={'left'}
                        value={input}
                        onChange={e => setInput(e.target.value)}
                        maxLength={4600}
                    />
                    {
                    // <p><b>Length</b>: {input.length}</p>
                    }
                </Col>
            </Row>
            <Row>
                <Col xs={1} style={{'paddingLeft': '25px'}}>
                    <Button 
                        className="btn-block"
                        variant="primary" 
                        size="sm"
                        id="button-addon2" 
                        onClick={() => {
                            console.log('clicked submit')
                            setIsBusy(isBusy => !isBusy)
                            setStart(Date.now())
                            setSummary('')
                            summarize(input)
                        }}
                    >                        
                        Submit
                    </Button>

                </Col>
                <Col>
                    <p>* could take a few minutes</p>
                </Col>
                <Col xs={5}>
                  {
                    isBusy &&
                    <Spinner animation="border" role="status" variant="primary">
                      <span className="visually-hidden">Loading...</span>
                    </Spinner>
                  }
                </Col>
                {
                // <Col>
                //     <p><b>Last: </b>
                //         {start < end && (end-start)/1000} s
                //     </p>
                // </Col>
                }
            </Row>
            <Row style={{ 'marginTop': '1em' }} >
                <Col>
                    {errorMessage && (
                        <Alert key="danger" variant="danger">
                            {errorMessage}
                        </Alert>
                    )}
                </Col>
            </Row>
            <Row>
                <Col style={{'padding': '25px', 'white-space': 'pre-wrap'}}>
                    <h2>Response</h2>
                    {
                    // <p><b>Summary: </b></p>
                    }
                    <TextAreaField 
                        alignContent={'left'}
                        value={summary}
                        isDisabled
                        // onChange={e => setInput(e.target.value)}
                        rows="9"
                    />
                </Col>
            </Row>
        {
            // <Row>
            //     <Col>
            //         <h3>Thing</h3>

            //     </Col>
        	   // <Col>
        	   //     <h2>Input text</h2>
            //         <textarea required value={input} onChange={(e) => setInput(e.target.value)}></textarea>
            //     </Col>
            //     <Col>
            //         <h2>Summary</h2>
            //         <p>{summary.summary_text}</p>
            //     </Col>
            //     <Col>

            //     </Col>
            //     <Col>
            //         <h2>Input</h2>
            //         <p>{input}</p>
            //     </Col>
        //   </Row>
        }
        </Container>
	);
};
export default ContentGeneration;